var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"clickable py-2 elevation-24",staticStyle:{"top":"-9px"},attrs:{"value":true,"color":"msr","icon":"info"},on:{"click":function($event){_vm.reloadPage()}}},[_c('v-layout',{attrs:{"align-center":""}},[_c('div',{staticClass:"subheading mr-3"},[_vm._v("\n        "+_vm._s(_vm.$t('pleaseReloadTheAppThereWasAnUpdate'))+"\n      ")]),_vm._v(" "),_c('v-btn',{staticClass:"ml-auto",attrs:{"icon":"","dark":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("\n          refresh\n        ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UpdateNeededAlert.vue?vue&type=template&id=5686daa9
// module id = 2648
// module chunks = 5